import { ComponentStyleConfig, defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  color: 'inherit',
});

export const formLabelTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle,
});
